import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import Breadcrumb from "../../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { Button, Card, CardContent, Grid, TextField } from "@mui/material";
import { useLocation, Redirect } from "react-router-dom";
import { callAPI } from "../../../App/Helpers/callApi";
import Signifier from "../../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../App/State/Slices/SelectedCareersClientSlice";
import { editJobGroup } from "../JobGroupsService";

function JobGroupDetailed() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "90%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "50%",
    },
    error: {
      color: theme.palette.error.main,
    },
    header: {
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        marginTop: "10px",
      },
      display: "flex",
    },
    descBlock: {
      display: "flex",
    },
    descLabel: {
      margin: "0px",
      fontWeight: "700",
      marginBottom: "10px",
    },
    descValue: {
      margin: "0px",
      marginLeft: "5px",
      marginRight: "20px",
    },
    copy: {
      color: theme.palette.primary.copy,
    },
  }));

  const classes = useStyles();

  let location = useLocation();
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);
  const selectCareersClient = useSelector(selectCareersClientValue);
  const [clientId, setClientId] = useState("");
  const [industryName, setIndustryName] = useState("");
  const [remarketingCode, setRemarketingCode] = useState("");
  const [atsName, setAtsName] = useState("");
  const [jobGroupId, setJobGroupId] = useState("");

  function saveGroup() {
    let data = {
      Id: jobGroupId,
      Name: industryName,
      remarketingCode: remarketingCode,
    };

    callAPI(
      editJobGroup(jobGroupId, data),
      "Group Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    );
  }

  useEffect(() => {
    if (location.state !== null && location.state !== undefined) {
      setClientId(location.state.clientId);
      setIndustryName(location.state.name);
      setRemarketingCode(location.state.remarketingCode);
      setAtsName(location.state.atsname);
      setJobGroupId(location.state.id);
    }
  }, []);

  if (location.state === null || location.state === undefined) {
    return <Redirect to="/jobgroups" />;
  }

  if (selectCareersClient.id !== clientId && clientId !== "") {
    return <Redirect to="/jobgroups" />;
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectCareersClient.shortName} Job Group Detailed
        </h1>
        <div className={classes.root}>
          <div className={classes.header}>
            <div className={classes.descBlock}>
              <p className={classes.descLabel}>INDUSTRY ATS NAME: </p>
              <p className={classes.descValue}>{atsName}</p>
            </div>
          </div>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid xs={12} sm={6} item>
                    <TextField
                      placeholder="Industry Name"
                      label="Industry Name"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={industryName}
                      onChange={(e) => setIndustryName(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Remarketing Code"
                      label="Remarketing Code"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={remarketingCode}
                      onChange={(e) => setRemarketingCode(e.target.value)}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    container
                    justifyContent="flex-end"
                  >
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() => saveGroup()}
                    >
                      Save Information
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </div>
      </div>
    </>
  );
}

export default JobGroupDetailed;
